<template lang="pug">
.d-flex
  .flex-grow-1
    filter-name.mr-2(:filter.sync="nameFilter")
    filter-suppliers.mr-2(:filter.sync="suppliersFilter")
    filter-reference.mr-2(:filter.sync="referenceFilter")
    filter-quotation-statuses.mr-2(:filter.sync="statusFilter")
    filter-date.mr-2(:filter.sync="dueDateFilter" title="Due date" param="due_date")
    filter-date.mr-2(:filter.sync="issueDateFilter" title="Date issued" param="record_date")
  v-btn.button-sm.underline.px-0(text :disabled="allFilters.length === 0" @click="resetFilters") Reset filters
</template>

<script>
import FilterName from '@/components/module/filter/FilterName.vue'
import FilterSuppliers from '@/components/clinic/purchasehub/filters/FilterSuppliers.vue'
import FilterReference from '@/components/clinic/purchasehub/filters/FilterReference.vue'
import FilterQuotationStatuses from '@/components/clinic/purchasehub/filters/FilterQuotationStatuses.vue'
import FilterDate from '@/components/module/filter/FilterDate.vue'

export default {
  components: {
    FilterName, FilterSuppliers, FilterReference, FilterQuotationStatuses, FilterDate
  },
  props: ['filters'],
  data: () => ({
    key: 0,
    nameFilter: {},
    suppliersFilter: {},
    referenceFilter: {},
    statusFilter: {},
    dueDateFilter: {},
    issueDateFilter: {},
  }),
  watch: {
    allFilters (newValue) {
      this.$emit('update:filters', newValue)
    }
  },
  computed: {
    allFilters () {
      const filters = []
      if (this.nameFilter.key) {
        filters.push(this.nameFilter)
      }
      if (this.suppliersFilter.key) {
        filters.push(this.suppliersFilter)
      }
      if (this.referenceFilter.key) {
        filters.push(this.referenceFilter)
      }
      if (this.statusFilter.key) {
        filters.push(this.statusFilter)
      }
      if (this.dueDateFilter.key) {
        if (this.dueDateFilter.key === 'between') {
          const values = this.dueDateFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.dueDateFilter)
        }
      }
      if (this.issueDateFilter.key) {
        if (this.issueDateFilter.key === 'between') {
          const values = this.issueDateFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.issueDateFilter)
        }
      }
      return filters
    }
  },
  methods: {
    resetFilters () {
      this.nameFilter = {}
      this.suppliersFilter = {}
      this.referenceFilter = {}
      this.statusFilter = {}
      this.dueDateFilter = {}
      this.issueDateFilter = {}
    },
  }
}
</script>
